'use client';

import React, { FC, useState } from "react";
import {
  MagnifyingGlassIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/lib/hooks";
import Logo from "@/shared/Logo";
import MenuBar from "@/shared/MenuBar";
import MobileSearchSheet from "../(Header)/MobileSearchSheet";

interface NavItem {
  key: string;
  name: string;
  link?: string;
  icon: any;
}

const HeroSearchForm2Mobile: FC = () => {
  const { t } = useTranslation("guydeez");
  const pathname = usePathname();
  const connectedUser = useAppSelector((state) => state.auth.user);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const cartItems = useAppSelector(state => state.cart.items);
  const cartItemCount = cartItems.length;

  const NAV: NavItem[] = [
    {
      key: "search",
      name: t("search"),
      icon: MagnifyingGlassIcon,
    },
    {
      key: "cart",
      name: t("cart"),
      icon: ShoppingCartIcon,
      link: "/checkout",
    },
    {
      key: "menu",
      name: t("menu"),
      icon: MenuBar,
    },
  ];

  const renderIcon = (item: NavItem) => {
    const isActive = pathname === item.link;

    if (item.key === "menu") {
      return (
        <div key={item.key} className="cursor-pointer">
          <item.icon className="text-white" />
        </div>
      );
    }

    if (item.key === "search") {
      return (
        <div
          key={item.key}
          className="cursor-pointer"
          onClick={() => setShowSearchModal(true)}
        >
          <item.icon className="w-6 h-6 text-white" />
        </div>
      );
    }

    if (item.key === "cart" && item.link) {
      return (
        <Link
          key={item.key}
          href={item.link}
          aria-label={(t('cart', { defaultValue: 'Cart' }) as string)}
          className="relative flex items-center"
        >
          <ShoppingCartIcon
            className={`w-6 h-6 ${isActive ? "text-red-600" : "text-white"}`}
            aria-hidden="true"
          />
          {cartItemCount > 0 && (
            <span className="absolute -top-1 -right-2 w-4 h-4 text-[10px] leading-none rounded-full bg-blue-500 text-white flex items-center justify-center">
              {cartItemCount}
            </span>
          )}
        </Link>
      );
    }

    if (item.link) {
      return (
        <Link key={item.key} href={item.link} className="flex items-center">
          <item.icon
            className={`w-6 h-6 ${isActive ? "text-red-600" : "text-white"}`}
          />
        </Link>
      );
    }

    return null;
  };

  return (
    <>
      <div className="HeroSearchForm2Mobile w-auto m-0 p-0 bg-transparent flex items-center justify-between">
        {/* Left: Logo */}
        <div className="flex-shrink-0">
          <Logo />
        </div>

        {/* Right: Icons */}
        <div className="flex items-center space-x-5 text-white mr-3">
          {NAV.map(renderIcon)}
        </div>
      </div>

      {showSearchModal && (
        <MobileSearchSheet onClose={() => setShowSearchModal(false)} />
      )}
    </>
  );
};

export default HeroSearchForm2Mobile;
